//! Auth
export const superadmin_admin_login = 'api/auth/superadmin-admin-login';
export const partner_login = 'api/auth/partner-login';

export const change_password = 'api/auth/change-password';
export const logout = '';

export const superadmin_admin_forget_password = 'api/auth/superadmin-admin-forget-password';
export const partner_forget_password = 'api/auth/partner-forget-password';
export const reset_password = 'api/auth/reset-password';

//* Superadmin-Admin-Partner Details
export const get_superadmin_admin_partner_details = 'api/auth/superadmin-admin-partner-details';

//! Dashboard
export const get_dashboard = 'api/partner/get-dashboard';
export const get_recent_activity = 'api/partner/get-recent-activity';

// Todo: Superadmin
//! Admin
export const get_admins = 'api/superadmin/get-admins';
export const get_admin_by_id = (adminId) => `api/superadmin/get-admin/${adminId}`;
export const create_admin = 'api/superadmin/create-admin';
export const update_admin = (adminId) => `api/superadmin/update-admin/${adminId}`;
export const delete_admin = (adminId) => `api/superadmin/delete-admin/${adminId}`;

//* Partner
export const get_partner_by_adminId = (adminId) => `api/superadmin/get-partner/${adminId}`;

//* Partner Bank Detail
export const get_partner_bank_details = ({ partnerId = '' }) => `api/superadmin/get-partner-bank-details?partnerId=${partnerId}`;
export const get_active_partner_bank_detail = ({ partnerId = '' }) => `api/superadmin/get-active-partner-bank-detail?partnerId=${partnerId}`;
export const create_partner_bank_detail = 'api/superadmin/create-partner-bank-detail';
export const update_partner_bank_detail = (id) => `api/superadmin/update-partner-bank-detail/${id}`;
export const delete_partner_bank_detail = (id) => `api/superadmin/delete-partner-bank-detail/${id}`;
export const change_partner_bank_detail_status = (id) => `api/superadmin/change-partner-bank-detail-status/${id}`;

//! Admin Report Wallet
export const get_admin_report_wallets = 'api/superadmin/get-admin-report-wallets';
export const create_admin_report_wallet = 'api/superadmin/create-admin-report-wallet';
export const update_admin_report_wallet = (reportWalletId) => `api/superadmin/update-admin-report-wallet/${reportWalletId}`;
export const delete_admin_report_wallet = (reportWalletId) => `api/superadmin/delete-admin-report-wallet/${reportWalletId}`;

//! Registration Number
export const get_registration_numbers = 'api/superadmin/get-registration-numbers';
export const create_registration_number = 'api/superadmin/create-registration-number';
export const update_registration_number = (registrationId) => `api/superadmin/update-registration-number/${registrationId}`;
export const delete_registration_number = (registrationId) => `api/superadmin/delete-registration-number/${registrationId}`;

//! Video
export const get_tutorials_videos = 'api/superadmin/get-videos?type=Tutorial';
export const get_business_videos = 'api/superadmin/get-videos?type=Business-Video';
export const create_video = 'api/superadmin/create-video';
export const update_video = (videoId) => `api/superadmin/update-video/${videoId}`;
export const delete_video = (videoId) => `api/superadmin/delete-video/${videoId}`;
export const change_video_status = (videoId) => `api/superadmin/change-video-status/${videoId}`;

//! Blogs
export const get_blogs = 'api/superadmin/get-blogs';
export const get_blog_by_id = (blogId) => `api/superadmin/get-blog/${blogId}`;
export const create_blog = 'api/superadmin/create-blog';
export const update_blog = (blogId) => `api/superadmin/update-blog/${blogId}`;
export const delete_blog = (blogId) => `api/superadmin/delete-blog/${blogId}`;

//! Coupon
export const get_coupons = 'api/superadmin/get-coupons';
export const create_coupon = 'api/superadmin/create-coupon';
export const update_coupon = (couponId) => `api/superadmin/update-coupon/${couponId}`;
export const delete_coupon = (couponId) => `api/superadmin/delete-coupon/${couponId}`;

//! Coupon
export const get_report_modules = 'api/report/get-report-modules';
export const get_reports = 'api/superadmin/get-reports';
export const create_report = 'api/superadmin/create-report';
export const update_report = (reportId) => `api/superadmin/update-report/${reportId}`;
export const delete_report = (reportId) => `api/superadmin/delete-report/${reportId}`;

export const get_generated_reports = 'api/payment/get-generated-reports';

// Todo: Admin Module
//! Partner
export const get_partners = ({ label }) => `api/admin/get-partners?label=${label}`;
export const get_partner_by_id = (partnerId) => `api/admin/get-partner/${partnerId}`;
export const create_partner = 'api/admin/create-partner';
export const update_partner = (partnerId) => `api/admin/update-partner/${partnerId}`;
export const delete_partner = (partnerId) => `api/admin/delete-partner/${partnerId}`;
export const change_partner_status = (partnerId) => `api/admin/change-partner-status/${partnerId}`;

//* Customer
export const get_customer_by_partnerId = (partnerId) => `api/admin/get-customer/${partnerId}`;
export const get_affiliate_by_partnerId = ({ partnerId }) => `api/admin/get-partners?label=Affiliate&partnerId=${partnerId}`;
export const get_customer_by_affiliateId = ({ affiliateId }) => `api/admin/get-customer/${affiliateId}`;

//! Partner Report Wallet
export const get_partner_report_wallets = 'api/admin/get-partner-report-wallets';
export const create_partner_report_wallet = 'api/admin/create-partner-report-wallet';
export const update_partner_report_wallet = (id) => `api/admin/update-partner-report-wallet/${id}`;
export const delete_partner_report_wallet = (id) => `api/admin/delete-partner-report-wallet/${id}`;

// Todo: Partner Module
//! Customer
export const get_customers = 'api/partner/get-customers';
export const get_customer_by_id = (customerId) => `api/partner/get-customer/${customerId}`;

//! Customer Report Wallet
export const get_customer_report_wallets = 'api/partner/get-customer-report-wallets';
export const create_customer_report_wallet = 'api/partner/create-customer-report-wallet';
export const update_customer_report_wallet = (id) => `api/partner/update-customer-report-wallet/${id}`;
export const delete_customer_report_wallet = (id) => `api/partner/delete-customer-report-wallet/${id}`;

// Todo: Setting
//! Static Page
export const create_update_static_page = 'api/superadmin/create-update-static-page';
export const get_terms_of_use = (user_type) => `api/superadmin/get-static-page?type=Terms-Of-Use&user_type=${user_type}`;
export const get_privacy_policy = (user_type) => `api/superadmin/get-static-page?type=Privacy-Policy&user_type=${user_type}`;
export const get_shipping_policy = (user_type) => `api/superadmin/get-static-page?type=Shipping-Policy&user_type=${user_type}`;
export const get_refund_policy = (user_type) => `api/superadmin/get-static-page?type=Refund-Policy&user_type=${user_type}`;
export const get_about_us = (user_type) => `api/superadmin/get-static-page?type=About-Us&user_type=${user_type}`;

//! Bug Tracker
export const get_bug_reports = (params = '') => `api/superadmin/get-bug-reports${params ? '?' + params : ''}`;
export const get_bug_report_by_id = (bugId) => `api/superadmin/get-bug-report/${bugId}`;
export const create_bug_report = 'api/superadmin/create-bug-report';
export const update_bug_report = (bugId) => `api/superadmin/update-bug-report/${bugId}`;
export const update_bug_status = (bugId) => `api/superadmin/update-bug-status/${bugId}`;
export const add_bug_comment = (bugId) => `api/superadmin/add-bug-comment/${bugId}`;
export const add_bug_resolution = (bugId) => `api/superadmin/add-bug-resolution/${bugId}`;
export const add_bug_test_report = (bugId) => `api/superadmin/add-bug-test-report/${bugId}`;
export const delete_bug_report = (bugId) => `api/superadmin/delete-bug-report/${bugId}`;
export const get_bug_stats = 'api/superadmin/get-bug-stats';
export const search_bug_reports = (search) => `api/superadmin/search-bug-reports?search=${search}`;

//! Site Settings
export const get_site_settings = 'api/superadmin/get-site-settings';
export const create_update_site_settings = 'api/superadmin/create-update-site-settings';

//! Awards
export const get_awards = 'api/superadmin/get-awards';
export const create_award = 'api/superadmin/create-award';
export const update_award = (awardId) => `api/superadmin/update-award/${awardId}`;
export const delete_award = (awardId) => `api/superadmin/delete-award/${awardId}`;
export const change_award_status = (awardId) => `api/superadmin/change-award-status/${awardId}`;

//! Media Coverage
export const get_media_coverage = 'api/superadmin/get-media-coverage';
export const create_media_coverage = 'api/superadmin/create-media-coverage';
export const update_media_coverage = (mediaId) => `api/superadmin/update-media-coverage/${mediaId}`;
export const delete_media_coverage = (mediaId) => `api/superadmin/delete-media-coverage/${mediaId}`;
export const change_media_coverage_status = (mediaId) => `api/superadmin/change-media-coverage-status/${mediaId}`;

//! Revenue
export const get_revenue_settings = 'api/superadmin/get-revenue-settings';
export const update_revenue_settings = 'api/superadmin/update-revenue-settings';
export const get_revenue_records = ({ start_date, end_date, filter_by, filter_id } = {}) => {
    const params = new URLSearchParams();
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (filter_by) params.append('filter_by', filter_by);
    if (filter_id) params.append('filter_id', filter_id);
    const role = localStorage.getItem('role');
    const base = role === 'Superadmin' ? 'api/superadmin' : 'api/partner';
    return `${base}/get-revenue-records?${params.toString()}`;
};
export const export_revenue_records = ({ start_date, end_date, filter_by, filter_id } = {}) => {
    const params = new URLSearchParams();
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (filter_by) params.append('filter_by', filter_by);
    if (filter_id) params.append('filter_id', filter_id);
    const role = localStorage.getItem('role');
    const base = role === 'Superadmin' ? 'api/superadmin' : 'api/partner';
    return `${base}/export-revenue-records?${params.toString()}`;
};

//! Testimonial Videos
export const get_testimonial_videos = 'api/superadmin/get-videos?type=Testimonial';

//! Payouts
export const get_payout_settings = 'api/superadmin/get-payout-settings';
export const toggle_auto_payout = 'api/superadmin/toggle-auto-payout';
export const get_pending_payouts = 'api/superadmin/get-pending-payouts';
export const process_payout = 'api/superadmin/process-payout';
export const process_all_payouts = 'api/superadmin/process-all-payouts';
export const get_payout_history = ({ start_date, end_date, recipient_type, status, page, limit } = {}) => {
    const params = new URLSearchParams();
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (recipient_type) params.append('recipient_type', recipient_type);
    if (status) params.append('status', status);
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    return `api/superadmin/get-payout-history?${params.toString()}`;
};